import { Container } from "components/Modules";
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className='my-24 max-w-6xl mx-auto text-text-primary'>
      <Container>
        <h1 className='text-[32px] text-text-dark font-bold'>Privacy Policy</h1>
        <p className='pb-[30px]'>Last updated: August 02, 2022</p>
        <p className=''>
          This Privacy Policy describes our policies and procedures on the
          collection, use and disclosure of your information when you use the
          service and tells you about your privacy rights and how the law
          protects you.
        </p>
        <p>
          We use your personal data to provide and improve the service. By using
          the service, you agree to the collection and use of information in
          accordance with this Privacy Policy.
        </p>
        <h2 className='text-[20px] text-text-dark mt-[20px]'>
          Collecting and using your personal data
        </h2>
        <h3 className='text-text-dark mt-[20px] font-semibold '>Usage data</h3>
        <p className='leading-[2rem]'>
          Usage data is collected automatically when using the service.
        </p>
        <p>
          {" "}
          Usage data may include information such as your device's internet
          protocol address (e.g. IP address), browser type, browser version, the
          pages of our service that you visit, the time and date of your visit,
          the time spent on those pages, unique device identifiers and other
          diagnostic data.
        </p>
        <p className=''>
          When you access the service by or through a mobile device, we may
          collect certain information automatically, including, but not limited
          to, the type of mobile device you use, your mobile device unique ID,
          the IP address of your mobile device, your mobile operating system,
          the type of mobile internet browser you use, unique device identifiers
          and other diagnostic data.
        </p>
        <p className=''>
          We may also collect information that your browser sends whenever you
          visit our service or when you access the service by or through a
          mobile device.
        </p>
        <h2 className='text-text-dark text-[16px] font-semibold mt-[20px]'>
          Tracking technologies and cookies
        </h2>
        <p className='mt-[20px]'>
          We use cookies and similar tracking technologies to track the activity
          on our service and store certain information. Tracking technologies
          used are beacons, tags, and scripts to collect and track information
          and to improve and analyze our service. The technologies we use may
          include:
        </p>
        <ul className='list-disc'>
          <li className='mt-[20px]'>
            <p className='text-text-dark font-bold'>
              Cookies or browser cookies
            </p>{" "}
            A cookie is a small file placed on your device. You can instruct
            your browser to refuse all cookies or to indicate when a cookie is
            being sent. However, if you do not accept cookies, you may not be
            able to use some parts of our service. Unless you have adjusted your
            browser setting so that it will refuse cookies, our service may use
            cookies.
          </li>
          <li className='mt-[20px]'>
            <h6 className='text-text-dark font-bold'>Flash cookies</h6>
            <p className=' mr-[4px] inline'>
              Certain features of our service may use locally stored objects (or
              flash cookies) to collect and store information about your
              preferences or your activity on our service. Flash cookies are not
              managed by the same browser settings as those used for browser
              cookies. For more information on how you can delete flash cookies,
              please read "Where shared objects?" available at
            </p>
            <a
              rel='noreferrer'
              target='_blank'
              href='https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change'
              className='group inline text-text-secondary ml-[2px] hover:underline transition-all duration-300'
            >
              https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change
            </a>
          </li>
          <li className='mt-[20px]'>
            <p className='text-text-dark font-bold'>Web beacons </p> Certain
            sections of our service and our emails may contain small electronic
            files known as web beacons (also referred to as clear gifs, pixel
            tags, and single-pixel gifs) that permit the Company, for example,
            to count users who have visited those pages or opened an email and
            for other related website statistics (for example, recording the
            popularity of a certain section and verifying system and server
            integrity).
          </li>
        </ul>
        <p>
          Cookies can be "Persistent" or "Session" cookies. Persistent cookies
          remain on your personal computer or mobile device when you go offline,
          while session cookies are deleted as soon as you close your web
          browser. Learn more about cookies:
          <a
            rel='noreferrer'
            target='_blank'
            href='https://policies.google.com/technologies/cookies?hl=en-US'
            className='group inline-block ml-[2px] text-text-secondary hover:underline transition-all duration-300'
          >
            What are cookies?.
          </a>
        </p>
        <h1 className='text-text-dark font-bold text-[20px] mt-[20px]'>
          Lorem Ipsum
        </h1>
        <h2 className='mt-[16px] text-text-dark font-semibold'>Usage data</h2>
        <p className='mt-[20px]'>
          Usage data is collected automatically when using the service.
        </p>
        <p className='mt-[20px]'>
          Usage data may include information such as your device's internet
          protocol address (e.g. IP address), browser type, browser version, the
          pages of our service that you visit, the time and date of your visit,
          the time spent on those pages, unique device identifiers and other
          diagnostic data.
        </p>
        <p>
          When you access the service by or through a mobile device, we may
          collect certain information automatically, including, but not limited
          to, the type of mobile device you use, your mobile device unique ID,
          the IP address of your mobile device, your mobile operating system,
          the type of mobile internet browser you use, unique device identifiers
          and other diagnostic data.
        </p>
        <p>
          We may also collect information that your browser sends whenever you
          visit our service or when you access the service by or through a
          mobile device.
        </p>
        <h2 className='text-text-dark text-[16px] font-semibold mt-[20px]'>
          Tracking technologies and cookies
        </h2>
        <p className='mt-[20px]'>
          We use cookies and similar tracking technologies to track the activity
          on our service and store certain information. Tracking technologies
          used are beacons, tags, and scripts to collect and track information
          and to improve and analyze our service. The technologies we use may
          include:
        </p>
        <ul className='list-disc'>
          <li className='mt-[20px]'>
            <p className='text-text-dark font-bold'>
              Cookies or browser cookies
            </p>{" "}
            We use cookies and similar tracking technologies to track the
            activity on our service and store certain information. Tracking
            technologies used are beacons, tags, and scripts to collect and
            track information and to improve and analyze our service. The
            technologies we use may include:
          </li>
          <li className='mt-[20px]'>
            <h6 className='text-text-dark font-bold mr-[4px]'>Flash cookies</h6>{" "}
            <p className='mr-[4px] inline'>
              Certain features of our service may use locally stored objects (or
              flash cookies) to collect and store information about your
              preferences or your activity on our service. Flash cookies are not
              managed by the same browser settings as those used for browser
              cookies. For more information on how you can delete flash cookies,
              please read "Where can I change the settings for disabling, or
              deleting local shared objects?" available at
            </p>
            <a
              rel='noreferrer'
              target='_blank'
              href='https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change'
              className='group inline  text-text-secondary hover:underline transition-all duration-300'
            >
              https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change
            </a>
          </li>
          <li className='mt-[20px]'>
            <p className='text-text-dark font-bold'>Web beacons </p> Certain
            sections of our service and our emails may contain small electronic
            files known as web beacons (also referred to as clear gifs, pixel
            tags, and single-pixel gifs) that permit the Company, for example,
            to count users who have visited those pages or opened an email and
            for other related website statistics (for example, recording the
            popularity of a certain section and verifying system and server
            integrity).
          </li>
        </ul>
        <p className='mt-6'>
          Cookies can be "Persistent" or "Session" cookies. Persistent cookies
          remain on your personal computer or mobile device when you go offline,
          while session cookies are deleted as soon as you close your web
          browser. Learn more about cookies:{" "}
          <a
            rel='noreferrer'
            target='_blank'
            href='https://policies.google.com/technologies/cookies?hl=en-US'
            className='group inline-block text-text-secondary hover:underline transition-all duration-300'
          >
            What are cookies?
          </a>
          .
        </p>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
